module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#tick",
      toString: function () {
        return this.url;
      }
    }